/**
 * What is left of the old role list, which is the two things in it that were never
 * roles at all.
 *
 * The six job-flavoured roles are gone. Access is a single level held on the account
 * and read as a set of permissions — see `app/auth/authRoles.js` and
 * `app/hooks/usePermission.js` — and what somebody does for the company is their
 * position, department and title.
 *
 * Both of the survivors keep their old spelling on purpose: they name values stored on
 * closings and payments, which exist by the thousand and are not being rewritten.
 */

/**
 * "Everybody" in the payroll employee pickers. A sentinel for the select, never a
 * value stored on an account.
 */
export const ALL_LOAN_OFFICERS = 'ALL_LOAN_OFFICERS';

/**
 * How each line on a payment is labelled in the payments table. The keys are
 * `payment.employeeRole`, written by the API when it works out who is owed what; the
 * matching list on that side is `COMPENSATION_ROLES` in `constants/compensation`.
 *
 * `BACKUP_ASSISTANT` was never a user role even before the split — it records that
 * somebody stood in on one closing.
 */
export const employeeCompensationRoles = {
  LOAN_OFFICER: 'Loan Officer',
  LOAN_OFFICER_ASSISTANT: 'Assistant',
  BACKUP_ASSISTANT: 'Backup Assistant'
};
